var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneyBillSolid1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 48,
    viewBox: "0 0 55 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.11111 6C2.74045 6 0 8.69063 0 12V36C0 39.3094 2.74045 42 6.11111 42H48.8889C52.2595 42 55 39.3094 55 36V12C55 8.69063 52.2595 6 48.8889 6H6.11111ZM12.2222 36H6.11111V30C9.48177 30 12.2222 32.6906 12.2222 36ZM6.11111 18V12H12.2222C12.2222 15.3094 9.48177 18 6.11111 18ZM42.7778 36C42.7778 32.6906 45.5182 30 48.8889 30V36H42.7778ZM48.8889 18C45.5182 18 42.7778 15.3094 42.7778 12H48.8889V18ZM27.5 15C29.9312 15 32.2627 15.9482 33.9818 17.636C35.7009 19.3239 36.6667 21.6131 36.6667 24C36.6667 26.3869 35.7009 28.6761 33.9818 30.364C32.2627 32.0518 29.9312 33 27.5 33C25.0688 33 22.7373 32.0518 21.0182 30.364C19.2991 28.6761 18.3333 26.3869 18.3333 24C18.3333 21.6131 19.2991 19.3239 21.0182 17.636C22.7373 15.9482 25.0688 15 27.5 15Z",
    fill: "#8DAF61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBillSolid1);
export default __webpack_public_path__ + "static/media/money-bill-solid 1.6d521ddd2368ff244a6e18c958a85817.svg";
export { ForwardRef as ReactComponent };